import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const Container = styled.div`
  background-color: ${Variables.colors.white};
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  border: 1px solid ${Variables.colors.complementary_400};
  padding: ${props =>
    props.bigSize ? "17px 52px 18px 32px" : "12px 8px 8px 8px"};
  display: flex;
  margin-bottom: 8px;
  &:last-child{
    margin-bottom: 0;
  }
  .icon-part {
    color: ${Variables.colors.complementary_600};
    margin-left: ${props => (props.bigSize ? "12.5px" : "8px")};
    &:before {
      font-size: ${props => (props.bigSize ? "42px" : "24px")};
    }
  }
  .main-part {
    flex: 1;
    .invitation-text {
      font-size: ${Variables.font_sizes.x_medium};
      color: ${Variables.colors.complementary_800};
    }
    .owner-text {
      display: flex;
      align-items: center;
      font-size: ${Variables.font_sizes.x_small};
      color: ${Variables.colors.complementary_600};
      margin: 8px 0 16px;
      padding: 2px 12px;
      & > i {
        margin-left: 6px;
        margin-bottom: 4px;
        &:before {
          font-size: 16px;
        }
      }
    }
    .actions-wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      & > div {
        margin-right: 6px;
        font-size: ${Variables.font_sizes.x_small};
        & > button {
          min-width: 80px;
        }
      }
    }
  }
`;
